<template>
    <div class="element-wrapper">
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <h4>Conheça mais sobre a clínica</h4>
                <p>{{rede.sobre}}</p>
            </div>
            
            <div class="col-md-4 col-sm-12">
                <h4>Especialidades</h4>
                <ul class="especialidades">
                    <li v-for="especialidade in especialidades" :key="especialidade._id">
                        {{ especialidade.nome }}
                    </li>
                </ul>
            </div>
            <div class="col-md-4 col-sm-12">
                <h4>Fotos</h4>
                <div class="row">
                    <div class="col-md-12" v-if="images.length > 0">
                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                          <ol class="carousel-indicators">
                            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                          </ol>
                          <div class="carousel-inner">
                            <div class="carousel-item" :class="{'active': i === 0}"
                              v-for="(redeImagem, i) in images" :key="redeImagem._id">
                              <img width="295px" height="395px" class="d-block w-100" :src="redeImagem.image" alt="First slide">
                            </div>
                          </div>
                          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Anterior</span>
                          </a>
                          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Próximo</span>
                          </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as http from 'axios'

export default {
  data () {
    return {
      images: []
    }
  },
  computed: {
    especialidades () {
      return this.$store.getters.redeSingle.especialidades
    },
    rede () {
      return this.$store.getters.redeSingle
    }
  },
  async mounted () {
    console.log('moutend xpTab')
    window.jQuery('.carousel').carousel()
    try {
      const response = await http.get('/redeImagem/' + this.rede._id)
      this.images = response.data
    } catch (error) {
      console.log(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/single-consultorio/XpTab.vue